import styled from 'styled-components';

export const Container = styled.div``;

export const ContentFocus = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0;

  animation: focus 1s;
  @keyframes focus {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  opacity: 1;
`;

export const Table = styled.div`
  padding-top: 1rem;
`;

export const DivSituation = styled.div`
  width: 18rem;
  display: flex;
  justify-content: center;

  gap: 1rem;
`;

export const Name = styled.h6`
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const Grade = styled.h6`
  width: 4rem;
`;

export const GradeCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
`;

export const ActivitiesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors?.gray03 || '#ddd'};
  font-size: 0.85em;
  text-align: left;
  width: 100%;
  min-width: 8rem;
`;

export const ActivityItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const ActivityName = styled.span`
  color: ${({ theme }) => theme.colors?.text?.secondary};
  flex: 1;
`;

export const ActivityGrade = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.text?.primary};
`;

export const H6 = styled.h6`
  width: 12rem;
`;

export const Title = styled.h6`
  max-width: 100%;
  font-weight: bold;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const DivDiscipline = styled.div`
  max-width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const TitleSmall = styled.h6`
  font-weight: bold;
`;
